export const TOKEN_KEY = 'token';
export const SESSION_INFO_KEY = 'infosesion';
export const BEARER_PREFIX = 'Bearer';
